import { FC, useEffect, useState } from "react";
import { useLogeMembers } from "../api/user-api";
import { GameTabs } from "../components/dss/GameTabs";
import Roulette from "../components/dss/roulette/Roulette";
import { RosterMember } from "../components/dss/roulette/wheelLayout";
import { Skeleton } from "../components/dss/Skeleton";

const RoulettePage: FC = () => {
  const { data: members, isLoading } = useLogeMembers();
  const [roster, setRoster] = useState<RosterMember[]>([]);

  // Shuffled once per visit, exactly as the lottery board does it: the wheel
  // deals the fields out in roster order, so shuffling is what decides who
  // sits next to whom — and, on a roster that doesn't divide into 21, who
  // collects the odd extra field.
  useEffect(() => {
    const eligible = (members ?? []).filter((m) => m.emoji);
    setRoster([...eligible].sort(() => Math.random() - 0.5));
  }, [members]);

  return (
    <div className="flex-1 flex flex-col min-h-0 px-4 pb-4">
      <GameTabs active="roulette" className="mt-2 mb-2.5" />
      <div className="flex-1 min-h-0">
        {isLoading ? (
          <Skeleton className="w-full h-full rounded-lg" />
        ) : roster.length < 2 ? (
          <div className="h-full flex items-center justify-center text-center font-mono text-[11px] text-ink3 px-6">
            Der skal være mindst 2 medlemmer på listen for at dreje rouletten.
          </div>
        ) : (
          <Roulette members={roster} />
        )}
      </div>
    </div>
  );
};

export default RoulettePage;
